import { handlize, money } from "../lib/util.functions";

class BundlerModal extends HTMLElement {
  #abortController;
  #main
  #contentType = 'content';

  constructor() {
    super();
    this.NAME = `BundlerModal`;
    let template = document.getElementById('bundler-modal-template');
    let templateContent = template.content;
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(templateContent.cloneNode(true));
    this.#main = this.shadowRoot.querySelector('main');
    this.closeBtn = this.shadowRoot.querySelector('[data-close-btn]');
  }

  connectedCallback() {
    this.closeBtn.addEventListener('click', () => this.dataset.show = 'false');
  }

  disconnectedCallback() {
    if (this.#abortController) {
      this.#abortController.abort();
      this.#abortController = null;
    }
  }

  static get observedAttributes() {
    return ['content-type', 'data-show', 'data-product-id', 'modal-style', 'data-quantity'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(this.NAME, name, oldValue, newValue);
    switch (name) {
      case 'data-show':
        this.#dispatchCustomEvent(newValue === 'false' ? 'close' : 'open');
        if (newValue === 'false' && this.#contentType !== 'confirm' && this.#contentType !== 'content') {
          if (this.#abortController) {
            this.#abortController.abort();
            this.#abortController = null;
          }
        } else if (newValue === 'true') {
          this.querySelector('[data-info]')?.scrollTo({top: 0, behavior: 'instant'});
        }
        break;

      case 'content-type':
        this.#contentType = newValue;
        if (newValue === 'form') {
          this.#addFormListeners();
        }
        if (newValue == 'product') {
          this.content = this.querySelector('[slot="modal-content"]');
          this.info = this.content.querySelector('[data-info]');
          this.img = this.content.querySelector('img');
        }
        if (newValue == 'confirm' || newValue == 'content') {
          this.content = this.querySelector('[slot="modal-content"]');
          this.#addButtonListeners();
        }
        break;
      
      case 'data-product-id':
        if (newValue && newValue !== '') {
          this.form = null;
          this.#populateProductInfo(newValue);
        }
        break;

      case 'modal-style':
        if (newValue && newValue !== '') {
          this.#main.setAttribute('style', newValue);
        }
        break;

      case 'data-quantity':
        if (newValue && newValue !== '') {
          const input = this.form?.querySelector('input[name="quantity"');
          if (input) {
            input.max = parseInt(input.max) - parseInt(newValue);
            if (newValue === '0') this.form.querySelectorAll('input[type=radio]').forEach(el => el.checked = false);
          }
        }
        break;
    
      default:
        break;
    }
  }

  #populateProductInfo(productId) {
    /* console.log(this.NAME, '#populateProductInfo', productId); */
    this.productID = productId;
    const productCard = document.querySelector(`product-card[data-product-id="${this.productID}"][data-group-index="${this.dataset.groupIndex}"]`);
    this.imgSrc = productCard.dataset.productImage;
    this.info.innerHTML = productCard.template.innerHTML;
    this.img.src = '';
    if (this.imgSrc) this.img.src = this.imgSrc;
    this.#addProductListeners();
    this.#addFormListeners();
  }

  #addButtonListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    const btns = this.content.querySelectorAll('button');
    //
    btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (this.#contentType === 'confirm') this.dataset.show = 'false';
        this.#dispatchCustomEvent(e.target.name);
      }, { signal });
    });
  }

  #addProductListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.productBtn = this.content.querySelector('[data-product-btn]');
    this.productBtnInput = this.productBtn?.querySelector('input');
    const input = this.content.querySelector('[data-update-quantity-input]');
    this.forms = this.querySelectorAll('product-form');
    //
    if (this.productBtn && !this.forms.length) this.productBtn.addEventListener('click', () => {
      this.#dispatchCustomEvent(this.productBtnInput.checked ? 'remove': 'add');
      this.productBtnInput.checked = !this.productBtnInput.checked;
      if (input) input.value = 1;
    }, { signal });
    //
    if (input) {
      input.addEventListener('input', (e) => {
        const data = {
          variantId: e.target.dataset.productVariant,
          quantity: e.target.value
        }
        this.#dispatchCustomEvent(e.target.name, data);
        if (e.target.value == 0) this.productBtnInput.checked = false;
      }, { signal });
    }
  }

  #addFormListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.productBtn.addEventListener('click', () => {
      if (this.productBtnInput.checked) {
        this.#dispatchCustomEvent('remove');
        this.productBtnInput.checked = false;
      } else {
        this.#onFormSubmit();
      }
    }, { signal });
    //
    if (this.querySelector('form[disabled')) return;
    //
    const totalPrice = [];
    const totalValid = [];
    //
    this.forms = this.querySelectorAll('product-form');
    this.forms.forEach((form, i, arr) => {
      totalValid.push(false);
      //
      if (i > 0 && form.dataset.connectedProduct == 'true') {
        arr[0].connectedProductForm = form;
      }
      //
      form.addEventListener('formevent', (e) => {
        console.log(e.detail)
        switch (e.detail.name) {
          case 'change':
            if (this.productBtnInput && this.productBtnInput.checked) {
              this.productBtnInput.checked = false;
            }
            break;

          case 'update':
            totalPrice[i] = e.detail.formData.totalPrice;
            totalValid[i] = e.detail.valid;
            //
            const valid = totalValid.reduce((a,b) => !a ? a : b, true);
            const price = totalPrice.reduce((a,b) => a + b, 0);
            //
            this.productBtnInput.disabled = !valid;
            this.productBtn.querySelector('[data-btn-text]').textContent = price ? ` ${money(price)}` : '';
            break;
        
          default:
            break;
        }
      }, { signal });
    });
  }

  #onFormSubmit() {
    this.forms.forEach((form, i) => {
      const data = form.getFormObject();
      //
      if (!i) {
        if (!data.image || data.image === '') data.image = this.imgSrc;
        this.#dispatchCustomEvent('form data', data);
        if (form.dataset.selectMultiple === 'true') {
          form.reset();
        } else if (this.productBtnInput) {
          this.productBtnInput.checked = true;
        }
      } else {
        this.#dispatchCustomEvent('form data', data);
        if (form.dataset.selectMultiple === 'true') form.reset();
      }
    })
  }

  #dispatchCustomEvent(name, otherData = {}) {
    const event = new CustomEvent('modalevent', {
      detail: {
        name,
        ...otherData
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('bundler-modal', BundlerModal);